export enum EAccountType {
  PAYMENT = 'PAYMENT',
  CONTROL = 'CONTROL',
}

export enum EAccountStatus {
  PENDING = 'PENDING',
  AWAITING_PROPOSAL_CREATION = 'AWAITING_PROPOSAL_CREATION',
  AWAITING_DOCUMENT_VALIDATION = 'AWAITING_DOCUMENT_VALIDATION',
  AWAITING_BACKGROUND_CHECK = 'AWAITING_BACKGROUND_CHECK',
  AWAITING_PROPOSAL_CONFIRMATION = 'AWAITING_PROPOSAL_CONFIRMATION',
  APPROVED = 'APPROVED',
  REJECTED_BACKGROUND_CHECK = 'REJECTED_BACKGROUND_CHECK',
  REJECTED_DOCUMENT = 'REJECTED_DOCUMENT',
  ACTIVE = 'ACTIVE',
}

export const accountStatusLabels: Record<EAccountStatus, string> = {
  PENDING: 'Pendente',
  AWAITING_PROPOSAL_CREATION: 'Criando proposta',
  AWAITING_DOCUMENT_VALIDATION: 'Validando documentos',
  AWAITING_BACKGROUND_CHECK: 'Análise regulatória',
  AWAITING_PROPOSAL_CONFIRMATION: 'Aguardando confirmação',
  APPROVED: 'Aprovada',
  REJECTED_BACKGROUND_CHECK: 'Rejeitada (check regulamentar)',
  REJECTED_DOCUMENT: 'Rejeitada (documentos)',
  ACTIVE: 'Ativa',
};

export interface IAccount {
  id: number;
  carrierBranchId: number;
  proposalId: string;
  accountType: EAccountType;
  status: EAccountStatus;
  rejectionReason?: string | null;
  kycLink?: string | null;
  cnpj: string;
  tradingName: string;
  businessName: string;
  phoneNumber: string;
  email: string;
  bankIspb: string;
  bankCode: string;
  bankBranch: string;
  bankAccount: string;
  pixKey: string;
  addressPostalCode: string;
  addressStreet: string;
  addressNumber: string;
  addressComplement: string;
  addressNeighborhood: string;
  addressCity: string;
  addressState: string;
  participants: any[];
  createdAt: string;
}

export interface IAccountDashboardBalance {
  accountId: number;
  accountType: EAccountType;
  balance: number;
  entriesTotal: number;
  exitsTotal: number;
}

export interface IPersonTermsAcceptance {
  personId: number;
  name: string;
  email: string;
  // Supervisors and owners only: other roles cannot open the banking page
  canAccept: boolean;
  accepted: boolean;
  acceptedAt?: string | null;
}

export interface IOnboardingAccount {
  id: number;
  carrierBranchId?: number | null;
  tradingName: string;
  cnpj: string;
  status: EAccountStatus;
  hasKycLink: boolean;
  rejectionReason?: string | null;
  createdAt: string;
  lastUpdateAt: string;
  daysSinceUpdate: number;
}

export interface IOnboardingOverview {
  activeCount: number;
  accounts: IOnboardingAccount[];
}
